import { ContentInterface, EduContentTypeEnum, EduFileInterface } from '.';

export class EduFile implements EduFileInterface, ContentInterface {
  private readonly eduFile: EduFileInterface;

  constructor(eduFile: EduFileInterface) {
    this.eduFile = eduFile;
  }

  get id(): number {
    return this.eduFile.id;
  }

  get type(): EduContentTypeEnum {
    return EduContentTypeEnum.FILE;
  }

  get name(): string {
    return this.eduFile.fileName;
  }

  get fileExtension(): string {
    return this.eduFile.file.split('.').pop();
  }

  get description(): string {
    return this.eduFile.eduContentMetadata.description;
  }

  get link(): undefined {
    return undefined;
  }
}
